/**
 * @module AEM
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

export const CONTAINER_CONSTANTS = {
  INVALID_AEM_CONTRACT: 'Invalid AEM Contract (Not of type ContentItem)',
  FAILED_CONTENT: 'Failed to get content',
  INVAILD_CONTAINER_INPUT: 'Container Holder has invalid input',
  INVALID_EXPECTED_CONTAINER_INPUT:
    'Container Holder has invalid input, expected items ' + 'to contain uiComponent and items',
};
